<ng-container *ngIf="selectedData; else loadingTemplate">
  <ng-container *ngIf="basket$ | async as basket">
    <div class="parts-header">
      <h3>
        <ng-container *ngIf="config.isBasketVisible">CART(<span><b>{{ basket | basketCount : config }}</b></span>)</ng-container>
        <ng-container *ngIf="!config.isBasketVisible">PARTS</ng-container>
      </h3>
      <button class="close-button" (click)="hideIsPartsVisible()">
        <app-icon name="close"></app-icon>
      </button>
    </div>
    <ul [ngClass]="{ 'parts-list': !config.isBasketVisible }">
      <li
        *ngFor="let piece of selectedData['piece'] | basketFilter : basket : config"
        (mouseenter)="hoverPiece(piece)"
        (mouseleave)="removeHoverPiece(piece)"
        [ngClass]="{
          active: config.currentHoveredNumber === piece.numident,
        }"
      >
        <button *ngIf="config.isBasketVisible" (click)="deleteFromBasket(piece)" class="remove-part">
          <app-icon class="warning" name="remove-rounded"></app-icon>
        </button>
        <div
          (click)="navigateToPartPage(piece)"
          [ngClass]="{
            clickable: config.isBasketVisible
          }"
        >
          <h4>
            {{ tryGuessName(piece) }}
          </h4>
          <h6>
            {{ piece['numident'] }}
          </h6>
        </div>

        <div *ngIf="config.isBasketVisible" class="quantity-container">
          <button (click)="removeFromBasket(piece.uid, piece.currentPageNumber, piece['id'])" [ngClass]="{ disabled: piece['count'] <= 1 }">
            <app-icon class="dark" name="decrement"></app-icon>
          </button>
          <input
            type="number"
            appInteger
            [min]="1"
            [max]="999"
            [default]="1"
            [ngModel]="piece['count']"
            (ngModelChange)="addCountToBasket(piece.uid, piece.currentPageNumber, piece['id'], piece, $event)"
          />
          <button (click)="addToBasket(piece.uid, piece.currentPageNumber, piece['id'], piece)">
            <app-icon class="dark" name="increment"></app-icon>
          </button>
        </div>
        <button
          *ngIf="!config.isBasketVisible"
          (click)="addToBasket(config.uid, config.currentPageNumber, piece['id'], piece)"
          class="add-to-basket"
        >
          <ng-container *ngIf="basket[config.uid] as _basket">
            <ng-container *ngIf="_basket[config.currentPageNumber] as _currentBasket">
              <ng-container *ngIf="_currentBasket[piece['id']] as _basketValue">
                <div class="count">
                  {{ _basketValue['count'] }}
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
          <app-icon class="dark" name="basket"></app-icon>
        </button>
      </li>
    </ul>
  </ng-container>
</ng-container>

<ng-template #loadingTemplate>
  <div class="loading"></div>
</ng-template>
